import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setQuestionAnswer, setQuestionAnswerFrench } from "../../../../redux/actions";
import styles from "./CDSAssistance.module.scss";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";

const CDSAssistanceView = ({ t, i18n }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { questionDataList } = useSelector((state) => state.app);
  const params = useParams();

  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer(
          "live-independently-check",
          "HARP Application",
          i18n.language
        );
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const onNext = (incomeAssistance) => () => {
    try {
      const answer = incomeAssistance ? "Yes" : "No";
      const answerFrench = incomeAssistance ? t("shared.yes") : t("shared.no");
      dispatch(setQuestionAnswer(3, answer));
      dispatch(setQuestionAnswerFrench(3, answerFrench));
      if (incomeAssistance) {
        navigate(`/${i18n.language}${t("routes.other_adults_living")}`);
      } else {
        navigate(`/${i18n.language}${t("routes.harp_age_check")}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(3, ''));
    dispatch(setQuestionAnswerFrench(3, ''));
  }

  const backPage = () => {
    const ans2 = questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 2)
    ].questionAnswer
    const ans4 = questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 4)
    ].questionAnswer

    if (ans2 === 'Yes' || ans4 === 'Yes') {
      return 'routes.heating_bill_opportunity'
    } else {
      return 'routes.heating_bill_not_needed'
    }
  }

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <BackAnchor backPath={backPage()} onBackClick={handleReduxCleanup} />
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>{t("harp_questions.income_assistance")}</h1>
              </div>
            </div>

            {/* Yes/No Answer */}
            <div className="row">
              <div className="col-lg-8">
                <div className="col-xs-2">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default`}
                    onClick={onNext(true)}
                    name={t("shared.yes")}
                  >
                    {t("shared.yes")}
                  </button>
                </div>

                <div className="col-xs-10">
                  <button
                    className={`${styles["question_button"]} btn-lg btn-default smallPaddingLeft`}
                    onClick={onNext(false)}
                    value={false}
                    name={t("shared.no")}
                  >
                    {t("shared.no")}
                  </button>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(CDSAssistanceView);
